"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderlyingPlatform = exports.StreamingType = exports.NEW_CONFIG_VALUE_SET = exports.CONFIG_FILE_UPDATED = exports.CONFIG_TEMPLATE_TO_REPLACE = exports.CONFIG_TEMPLATE_DIVIDER = exports.DEFAULT_CONFIG_FILE_EXTENSION = exports.DEFAULT_CONFIG_PLATFORM = exports.DEFAULT_CONFIG_FILE_NAME = exports.DEFAULT_CONFIG_DIR = void 0;
exports.DEFAULT_CONFIG_DIR = '.';
exports.DEFAULT_CONFIG_FILE_NAME = 'rdplibconfig';
exports.DEFAULT_CONFIG_PLATFORM = 'prod';
exports.DEFAULT_CONFIG_FILE_EXTENSION = 'json';
exports.CONFIG_TEMPLATE_DIVIDER = ':';
exports.CONFIG_TEMPLATE_TO_REPLACE = /\$\{(.*?)\}/gm;
exports.CONFIG_FILE_UPDATED = 'update';
exports.NEW_CONFIG_VALUE_SET = 'set';
var StreamingType;
(function (StreamingType) {
    StreamingType["OMM"] = "OMM";
    StreamingType["RDP"] = "RDP";
})(StreamingType || (exports.StreamingType = StreamingType = {}));
var UnderlyingPlatform;
(function (UnderlyingPlatform) {
    UnderlyingPlatform["RDP"] = "rdp";
    UnderlyingPlatform["UDF"] = "udf";
})(UnderlyingPlatform || (exports.UnderlyingPlatform = UnderlyingPlatform = {}));
